import React, { useState } from "react";
import axios from 'axios';
import emailjs from 'emailjs-com';
import {
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Button,
    TextField,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Typography,
    Checkbox,
    FormControlLabel,
    Grid,
    Snackbar
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import '../Components/sgpform2025.css';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    rootouter: {
        backgroundColor: '#fff',
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'bottom',
    },
    divider: {
        backgroundColor: '#002147',
    },
    root: {
        margin: '24px 0px',
        position: 'relative',
        backgroundColor: '#fff',
        maxWidth: '900px',
        top: '-17.5vw',
        padding: '60px 20px 60px 20px',
        boxShadow: '0 0 10px 0 rgba(0,0,0,0.2)',	
        borderRadius: '25px',
        '& p': {
            fontSize: '0.9rem',
        },
        '@media (min-width: 768px)': {
          marginLeft: 'auto',
          marginRight: 'auto',
          padding: '60px 80px 60px 80px',
          borderRadius: '5px'
        }
    },
    redText: {
        color: '#b91c1c',
    },
    stepper: {
        background: 'transparent',
        padding: 0,
        marginBottom: theme.spacing(3),
    },
    stepperVertical: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        '& .MuiStepConnector-root': {
            marginLeft: 12,
        }
    },
    stepContent: {
        marginTop: theme.spacing(2),
    },
    sectionTitle: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontWeight: 700,
        color: '#1f2937',
    },
    card: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    cardGroupGrid: {
        display: 'flex',
        flexDirection: 'column'
    },
    cardContentGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 120px 100px 140px',
        gap: theme.spacing(2),
        alignItems: 'top',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr', // single column on mobile
            gap: theme.spacing(1.25),
            alignItems: 'stretch',
            // ensure child controls expand full width
            '& > *': {
                width: '100%',
            },
            // reduce Card padding a bit on small screens for better fit
            '& $card': {
                padding: theme.spacing(1),
            },
            marginBottom: '30px'
        },
    },
    field: {
        width: '100%',
        paddingRight: '10px'
    },
    addButton: {
        marginTop: theme.spacing(1),
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: theme.spacing(3),
    },
    primaryButton: {
        backgroundColor: '#0b488fff',
        borderColor: '#0b488fff',
        color: '#fff',
        marginLeft: theme.spacing(1),
        '&:hover': {
            backgroundColor: '#082f5bff',
            borderColor: '#082f5bff',
            color: '#fff',
        },
    },
    secondaryButton: {
        color: theme.palette.error.main,
    },
    errorText: {
        color: theme.palette.error.main,
        marginTop: theme.spacing(1),
        fontSize: '0.95rem',
    },
    duplicatesBox: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        borderRadius: 8,
        background: 'rgba(255,235,238,0.7)',
        border: `1px solid ${theme.palette.error.light}`,
        color: theme.palette.error.dark,
    },
    rulesBox: {
        border: '1px solid rgba(15,23,42,0.06)',
        fontSize: '0.9rem',
        borderRadius: 10,
        padding: theme.spacing(2),
        background: '#fafafa',
        maxHeight: 360,
        overflowY: 'auto',
        marginBottom: theme.spacing(2),
    },
    formField: {
        marginBottom: theme.spacing(3),
    },
    previewTable: {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: theme.spacing(2),
    },
    previewTableCell: {
        padding: theme.spacing(1.5),
        border: '1px solid #e0e0e0',
        textAlign: 'left',
    },
    previewTableHeader: {
        backgroundColor: '#f5f5f5',
        fontWeight: 600,
        color: '#333',
    },
    aadharImage: {
        maxWidth: '200px',
        maxHeight: '200px',
        borderRadius: '4px',
        marginTop: theme.spacing(1),
    },
    uploadedImg: {
        height: '100px',
        paddingLeft: '20px'
    },
}));

export default function NarmadaParikrama2026() {
    const classes = useStyles();

    const steps = [
        "Rules & Regulations",
        "Personal Details",
        "Other details",
        "Travel Preference",
        "Preview & Submit",
    ];

    const [activeStep, setActiveStep] = useState(0);
    const [errors, setErrors] = useState({});
    const [consentChecked, setConsentChecked] = useState(false);

    // Personal Details
    const [fullName, setFullName] = useState("");
    const [age, setAge] = useState("");
    const [gender, setGender] = useState("");
    const [city, setCity] = useState("");
    const [email, setEmail] = useState("");
    const [whatsapp, setWhatsapp] = useState("");

    // Other details
    const [panNumber, setPanNumber] = useState("");
    const [medicalIssue, setMedicalIssue] = useState("");
    const [aadharCard, setAadharCard] = useState(null);

    // Travel Preference
    const [travelPreference, setTravelPreference] = useState("");
    const [familyMembers, setFamilyMembers] = useState([]);

    const price = (travelPreference === "Personal Vehicle" ? (250 * (1 + familyMembers.length)) : travelPreference === "Avail Bus Option" ? 600 : 0);

    // Payment related states
    const [userid, setuserid] = useState('');
    const [message, setmessage] = useState(false);
    const [formstatus, setformstatus] = useState('error');
    const [logtext, setlogtext] = useState('');
    const [issubmitting, setissubmitting] = useState(false);



    // helpers
    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const validatePhone = (phone) => {
        const digits = (phone || '').replace(/\D/g, '');
        return digits.length === 10;
    };

    const validateStep = (step = activeStep) => {
        const newErrors = {};

        if (step === 0) {
            if (!consentChecked) newErrors.consent = "You must read and agree to the rules to continue";
        }

        if (step === 1) {
            if (!fullName.trim()) newErrors.fullName = "Full name is required";
            if (!age.trim()) newErrors.age = "Age is required";
            else if (Number.isNaN(parseInt(age, 10)) || parseInt(age, 10) <= 0) newErrors.age = "Enter a valid age";
            if (!gender) newErrors.gender = "Gender is required";
            if (!city.trim()) newErrors.city = "City is required";
            if (!email.trim()) newErrors.email = "Email is required";
            else if (!validateEmail(email)) newErrors.email = "Enter a valid email address";
            if (!whatsapp.trim()) newErrors.whatsapp = "Whatsapp number is required";
            else if (!validatePhone(whatsapp)) newErrors.whatsapp = "Enter a valid mobile number (10 digits)";
        }

        if (step === 2) {
            if (!panNumber.trim()) newErrors.panNumber = "PAN Number is required";
            if (!medicalIssue) newErrors.medicalIssue = "Please specify if you have any medical issue";
            if (!aadharCard) newErrors.aadharCard = "Aadhar card upload is required";
        }

        if (step === 3) {
            if (!travelPreference) newErrors.travelPreference = "Travel preference is required";
            if (travelPreference === "Personal Vehicle") {
                familyMembers.forEach((member, index) => {
                    if (!member.fullName.trim()) newErrors[`familyMember_${index}_fullName`] = "Full name is required";
                    if (!member.gender) newErrors[`familyMember_${index}_gender`] = "Gender is required";
                    if (!member.age.trim()) newErrors[`familyMember_${index}_age`] = "Age is required";
                    else if (Number.isNaN(parseInt(member.age, 10)) || parseInt(member.age, 10) <= 0) newErrors[`familyMember_${index}_age`] = "Enter a valid age";
                    if (!member.medicalIssue) newErrors[`familyMember_${index}_medicalIssue`] = "Please specify if you have any medical issue";
                });
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateAll = () => {
        const allErrors = {};
        if (!consentChecked) allErrors.consent = "You must read and agree to the rules to continue";

        if (!fullName.trim()) allErrors.fullName = "Full name is required";
        if (!age.trim()) allErrors.age = "Age is required";
        else if (Number.isNaN(parseInt(age, 10)) || parseInt(age, 10) <= 0) allErrors.age = "Enter a valid age";
        if (!gender) allErrors.gender = "Gender is required";
        if (!city.trim()) allErrors.city = "City is required";
        if (!email.trim()) allErrors.email = "Email is required";
        else if (!validateEmail(email)) allErrors.email = "Enter a valid email address";
        if (!whatsapp.trim()) allErrors.whatsapp = "Whatsapp number is required";
        else if (!validatePhone(whatsapp)) allErrors.whatsapp = "Enter a valid mobile number (10 digits)";

        if (!travelPreference) allErrors.travelPreference = "Travel preference is required";
        if (travelPreference === "Personal Vehicle") {
            familyMembers.forEach((member, index) => {
                if (!member.fullName.trim()) allErrors[`familyMember_${index}_fullName`] = "Full name is required";
                if (!member.gender) allErrors[`familyMember_${index}_gender`] = "Gender is required";
                if (!member.age.trim()) allErrors[`familyMember_${index}_age`] = "Age is required";
                else if (Number.isNaN(parseInt(member.age, 10)) || parseInt(member.age, 10) <= 0) allErrors[`familyMember_${index}_age`] = "Enter a valid age";
                if (!member.medicalIssue) allErrors[`familyMember_${index}_medicalIssue`] = "Please specify if you have any medical issue";
            });
        }

        if (!panNumber.trim()) allErrors.panNumber = "PAN Number is required";
        if (!medicalIssue) allErrors.medicalIssue = "Please specify if you have any medical issue";
        if (!aadharCard) allErrors.aadharCard = "Aadhar card upload is required";

        setErrors(allErrors);
        return Object.keys(allErrors).length === 0;
    };

    const addFamilyMember = () => {
        if (familyMembers.length < 6) {
            setFamilyMembers([...familyMembers, { fullName: '', gender: '', age: '', medicalIssue: '' }]);
        }
    };

    const updateFamilyMember = (index, field, value) => {
        const updated = [...familyMembers];
        updated[index][field] = value;
        setFamilyMembers(updated);
    };

    const deleteFamilyMember = (index) => {
        setFamilyMembers(familyMembers.filter((_, i) => i !== index));
    };

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
            resolve(true);
            };
            script.onerror = () => {
            resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    const initiateSubmission = async (formData, e) => {
        await loadScript("https://checkout.razorpay.com/v1/checkout.js");
        setmessage(true);
        setformstatus('info');
        setlogtext('Submitting... Please wait !');
        setissubmitting(true);
        await axios({
            url: 'https://satprerna.org/satprerna_backend/home/npk2026_register.php',
            method: 'post',
            data: formData,
            responseType: 'json'
        })
        .then((response) => {
            // console.log(response);
            setuserid(response.data.id);
            if (price > 0) {
                setformstatus('info');
                setlogtext('Please complete payment...');
                paymentHandler(response.data.id, e)
            }
            else {
                setmessage(true);
                setformstatus('success');
                setlogtext('Submitted Successfully !');
                setissubmitting(false);
                // todo : sendEmail(email); 
                // Reset form
                setFullName('');
                setAge('');
                setGender('');
                setCity('');
                setEmail('');
                setWhatsapp('');
                setPanNumber('');
                setMedicalIssue('');
                setAadharCard(null);
                setTravelPreference('');
                setFamilyMembers([]);
                setActiveStep(0);
                setConsentChecked(false);
            }
        })
        .catch(err => {
            // console.log('err', err)
            setmessage(true)
            setformstatus('error')
            setlogtext('Something went wrong !')
            setissubmitting(false);
        })
    }

    const paymentHandler = (id, e) => {
        e.preventDefault();
        const options = {
            key: 'rzp_live_bH8zSPYWzsshms',
            amount: price * 100,
            name: 'Satprerna Trust',

            "handler": async function (response) {
                const paymentId = response.razorpay_payment_id;
                const formData = new FormData();
                formData.append("razorpay_payment_id", paymentId);
                formData.append("payment_status", "Paid");
                formData.append("id", id);
                setmessage(true);
                setformstatus('info');
                setlogtext('Submitting...');
                await axios({
                    url: 'https://satprerna.org/satprerna_backend/home/npk2026_update_status.php',
                    method: 'post',
                    data: formData,
                    responseType: 'json'
                })
                .then(() => {
                    setmessage(true);
                    setformstatus('success');
                    setlogtext('Payment Completed Successfully !');
                    setissubmitting(false);
                    sendEmail(email);
                    // Reset form
                    setFullName('');
                    setAge('');
                    setGender('');
                    setCity('');
                    setEmail('');
                    setWhatsapp('');
                    setPanNumber('');
                    setMedicalIssue('');
                    setAadharCard(null);
                    setTravelPreference('');
                    setFamilyMembers([]);
                    setActiveStep(0);
                    setConsentChecked(false);
                })
                .catch(err => {
                    // console.log('err', err)
                    setmessage(true)
                    setformstatus('error')
                    setlogtext('Something went wrong')
                    setissubmitting(false);
                })
            },
            modal: {
                escape: false,
                ondismiss() {
                    setmessage(true);
                    setformstatus('error')
                    setlogtext('Payment Failed. Registration Cancelled !')
                    setissubmitting(false);
                }
            },
            prefill: {
                name: fullName,
                email: email
            },
            notes: {
                address: city
            },
            theme: {
                color: '#fa6400',
            },
        };
        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    }

    const handleNext = () => {
        if (!validateStep()) return;
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => setActiveStep((prev) => prev - 1);

    const renderStepContent = (key) => {
        switch (key) {
            case 0:
                return (
                    <div className={classes.stepContent}>
                        <div className={classes.rulesBox}>
                            <RulesContent />
                        </div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={consentChecked}
                                    onChange={(e) => {
                                        setConsentChecked(e.target.checked);
                                        if (errors.consent) {
                                            setErrors(prev => { const copy = { ...prev }; delete copy.consent; return copy; });
                                        }
                                    }}
                                    color="primary"
                                />
                            }
                            label="I have read carefully and agree to the Rules and Terms & Conditions"
                        />
                        {errors.consent && <p className={classes.errorText}>{errors.consent}</p>}
                    </div>
                );

            case 1:
                return (
                    <div className={classes.stepContent}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Full Name"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            required
                            error={!!errors.fullName}
                            helperText={errors.fullName}
                            className={classes.formField}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Age"
                            value={age}
                            onChange={(e) => setAge(e.target.value.replace(/\D/g, ''))}
                            required
                            error={!!errors.age}
                            helperText={errors.age}
                            className={classes.formField}
                        />
                        <FormControl variant="outlined" fullWidth error={!!errors.gender} className={classes.formField}>
                            <InputLabel>Gender</InputLabel>
                            <Select
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                required
                                MenuProps={{
                                    disableScrollLock: true
                                }}
                            >
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>
                            </Select>
                            {errors.gender && <p className={classes.errorText}>{errors.gender}</p>}
                        </FormControl>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="City"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            required
                            error={!!errors.city}
                            helperText={errors.city}
                            className={classes.formField}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Email ID"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            error={!!errors.email}
                            helperText={errors.email}
                            className={classes.formField}
                        />
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="WhatsApp Number"
                            value={whatsapp}
                            onChange={(e) => setWhatsapp(e.target.value.replace(/\D/g, ''))}
                            required
                            error={!!errors.whatsapp}
                            helperText={errors.whatsapp}
                            className={classes.formField}
                        />
                    </div>
                );

            case 2:
                return (
                    <div className={classes.stepContent}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="PAN Number"
                            value={panNumber}
                            onChange={(e) => setPanNumber(e.target.value)}
                            required
                            error={!!errors.panNumber}
                            helperText={errors.panNumber}
                            className={classes.formField}
                        />
                        <FormControl variant="outlined" fullWidth error={!!errors.medicalIssue} className={classes.formField}>
                            <InputLabel>Do you have any medical issue?</InputLabel>
                            <Select
                                value={medicalIssue}
                                onChange={(e) => setMedicalIssue(e.target.value)}
                                required
                                MenuProps={{
                                    disableScrollLock: true
                                }}
                            >
                                <MenuItem value="yes">Yes</MenuItem>
                                <MenuItem value="no">No</MenuItem>
                            </Select>
                            {errors.medicalIssue && <p className={classes.errorText}>{errors.medicalIssue}</p>}
                        </FormControl>
                        <div className={classes.formField}>
                            <input 
                                type="file" 
                                id="contained-button-file-2" 
                                accept="image/*" 
                                onChange={(e) => setAadharCard(e.target.files[0])}
                                style={{ display: 'none' }} 
                            />
                            <label htmlFor="contained-button-file-2">
                                <Button variant="contained" color="primary" component="span" size="large">
                                    Upload Government Issued Aadhar Card
                                </Button>
                            </label>
                            { aadharCard && <img src={URL.createObjectURL(aadharCard)} alt="" className={classes.uploadedImg} /> }
                            {errors.aadharCard && <p className={classes.errorText}>{errors.aadharCard}</p>}
                        </div>
                    </div>
                );

            case 3:
                return (
                    <div className={classes.stepContent}>
                        <FormControl variant="outlined" fullWidth error={!!errors.travelPreference} className={classes.formField}>
                            <InputLabel>Travel Preference</InputLabel>
                            <Select
                                value={travelPreference}
                                onChange={(e) => setTravelPreference(e.target.value)}
                                required
                                MenuProps={{
                                    disableScrollLock: true
                                }}
                            >
                                <MenuItem value="Personal Vehicle">Personal Vehicle (₹250 per person) </MenuItem>
                                <MenuItem value="Avail Bus Option">Bus (₹600 per person)</MenuItem>
                            </Select>
                            {errors.travelPreference && <p className={classes.errorText}>{errors.travelPreference}</p>}
                        </FormControl>
                        {travelPreference === "Personal Vehicle" && (
                            <div>
                                {familyMembers.map((member, index) => (
                                    <div key={index} className={classes.card}>
                                        <Typography variant="h6" style={{ marginBottom: '10px' }}>Family Member {index + 1}</Typography>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Full Name"
                                                    value={member.fullName}
                                                    onChange={(e) => updateFamilyMember(index, 'fullName', e.target.value)}
                                                    error={!!errors[`familyMember_${index}_fullName`]}
                                                    helperText={errors[`familyMember_${index}_fullName`]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl variant="outlined" fullWidth error={!!errors[`familyMember_${index}_gender`]}>
                                                    <InputLabel>Gender</InputLabel>
                                                    <Select
                                                        value={member.gender}
                                                        onChange={(e) => updateFamilyMember(index, 'gender', e.target.value)}
                                                    >
                                                        <MenuItem value="Male">Male</MenuItem>
                                                        <MenuItem value="Female">Female</MenuItem>
                                                    </Select>
                                                    {errors[`familyMember_${index}_gender`] && <p className={classes.errorText}>{errors[`familyMember_${index}_gender`]}</p>}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Age"
                                                    value={member.age}
                                                    onChange={(e) => updateFamilyMember(index, 'age', e.target.value.replace(/\D/g, ''))}
                                                    error={!!errors[`familyMember_${index}_age`]}
                                                    helperText={errors[`familyMember_${index}_age`]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl variant="outlined" fullWidth error={!!errors[`familyMember_${index}_medicalIssue`]}>
                                                    <InputLabel>Any medical issue?</InputLabel>
                                                    <Select
                                                        value={member.medicalIssue}
                                                        onChange={(e) => updateFamilyMember(index, 'medicalIssue', e.target.value)}
                                                    >
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                    {errors[`familyMember_${index}_medicalIssue`] && <p className={classes.errorText}>{errors[`familyMember_${index}_medicalIssue`]}</p>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => deleteFamilyMember(index)}
                                            style={{ marginTop: '30px' }}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                ))}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={addFamilyMember}
                                    disabled={familyMembers.length >= 6}
                                    className={classes.addButton}
                                >
                                    Add Family Member
                                </Button>
                            </div>
                        )}
                    </div>
                );

            case 4:
                return (
                    <div className={classes.stepContent}>
                        <Typography variant="h6" style={{ marginBottom: '20px' }}>Preview Your Details</Typography>
                        <table className={classes.previewTable}>
                            <tbody>
                                <tr>
                                    <td className={`${classes.previewTableCell} ${classes.previewTableHeader}`}><strong>Field</strong></td>
                                    <td className={`${classes.previewTableCell} ${classes.previewTableHeader}`}><strong>Details</strong></td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Full Name of Primary Registrant</td>
                                    <td className={classes.previewTableCell}>{fullName}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Age</td>
                                    <td className={classes.previewTableCell}>{age}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Gender</td>
                                    <td className={classes.previewTableCell}>{gender}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>City</td>
                                    <td className={classes.previewTableCell}>{city}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Email</td>
                                    <td className={classes.previewTableCell}>{email}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>WhatsApp</td>
                                    <td className={classes.previewTableCell}>{whatsapp}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Travel Preference</td>
                                    <td className={classes.previewTableCell}>{travelPreference}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Registered Members</td>
                                    <td className={classes.previewTableCell}>
                                        {'Name : ' + fullName} <br />
                                        {familyMembers.map((member, index) => (
                                            <React.Fragment key={index}>
                                                {'Name : ' + member.fullName} <br />
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                {/* {familyMembers.map((member, index) => (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td className={classes.previewTableCell}>Family Member {index + 1}</td>
                                            <td className={classes.previewTableCell}>
                                                {'Name : ' + member.fullName} <br />
                                                {'Gender : ' + member.gender} <br />
                                                {'Age : ' + member.age} <br />
                                                {'Medical Issue : ' + member.medicalIssue}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))} */}
                                <tr>
                                    <td style={{ color: 'red' }} className={classes.previewTableCell}>Amount (to be paid) :</td>
                                    <td style={{ color: 'red' }} className={classes.previewTableCell}>₹{price}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>PAN Number</td>
                                    <td className={classes.previewTableCell}>{panNumber}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Medical Issue</td>
                                    <td className={classes.previewTableCell}>{medicalIssue}</td>
                                </tr>
                                <tr>
                                    <td className={classes.previewTableCell}>Aadhar Card</td>
                                    <td className={classes.previewTableCell}>
                                        {aadharCard ? (
                                            <div>
                                                <p style={{ margin: '8px 0' }}>{aadharCard.name}</p>
                                                <img
                                                    src={URL.createObjectURL(aadharCard)}
                                                    alt="Aadhar Card"
                                                    className={classes.aadharImage}
                                                />
                                            </div>
                                        ) : (
                                            'Not uploaded'
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {price>0 && <Grid container spacing={1}>
                        <p style={{ color: 'red', marginTop: '30px' }}>
                            <b>Registration will be marked completed only after payment of ₹{price} is done in next step / अगले चरण में ₹{price} का भुगतान होने के बाद ही पंजीकरण पूर्ण माना जाएगा :</b><br /><br />
                            <b>Acknowledgement email will be sent on the provided email address after payment confirmation.</b><br /><br />
                        </p>
                        </Grid>}
                    </div>
                );

            default:
                return null;
        }
    };


    const handleFormSubmit = (e) => {
        if (!validateAll()) return;

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('consent', consentChecked ? 1 : 0);
        formData.append('fullName', fullName.trim());
        formData.append('age', age.trim());
        formData.append('gender', gender);
        formData.append('city', city.trim());
        formData.append('email', email.trim());
        formData.append('whatsapp', whatsapp.trim());
        formData.append('travelPreference', travelPreference);
        formData.append('familyMembers', JSON.stringify(familyMembers));
        formData.append('panNumber', panNumber.trim());
        formData.append('medicalIssue', medicalIssue);
        formData.append('price', price);
        formData.append('payment_status', 'pending');
        formData.append('razorpay_payment_id', '');
        if (aadharCard) {
            formData.append('aadharCard', aadharCard);
        }

        initiateSubmission(formData, e);
    };

    const tableWrapper = (rows) => `
        <table border="1" cellpadding="6" cellspacing="0" width="100%" style="border-collapse:collapse;">
            <tr style="background:#e8f0fe;">
                <th>Sr. No</th>
                <th>Name</th>
            </tr>
            ${rows}
        </table>`;

    const previewTable = () => `
        <table border="1" cellpadding="6" cellspacing="0" width="100%" style="border-collapse:collapse;">
            <tbody>
                <tr style="background:#e8f0fe;">
                    <td><strong>Field</strong></td>
                    <td><strong>Details</strong></td>
                </tr>
                <tr>
                    <td>Primary Registrant</td>
                    <td>${fullName}</td>
                </tr>
                <tr>
                    <td>Age</td>
                    <td>${age}</td>
                </tr>
                <tr>
                    <td>Gender</td>
                    <td>${gender}</td>
                </tr>
                <tr>
                    <td>City</td>
                    <td>${city}</td>
                </tr>
                <tr>
                    <td>Email</td>
                    <td>${email}</td>
                </tr>
                <tr>
                    <td>WhatsApp</td>
                    <td>${whatsapp}</td>
                </tr>
                <tr>
                    <td>Travel Preference</td>
                    <td>${travelPreference}</td>
                </tr>
                <tr>
                    <td>Total Registered Members</td>
                    <td>${familyMembers.length + 1}</td>
                </tr>
                <tr>
                    <td >Amount paid :</td>
                    <td >₹${price}</td>
                </tr>
                <tr>
                    <td>Medical Issue</td>
                    <td>${medicalIssue}</td>
                </tr>
            </tbody>
        </table>`;
    
    const buildRows = (familyMembers) =>
        familyMembers
        .map(
            (s, index) => `
            <tr>
                <td>${index + 1}</td>
                <td>${s.fullName}</td>
            </tr>`
        )
        .join("");

    const notParticipated = `
        <p style="font-style:italic; color:#777;">
            Not Applicable for Bus Travelers / बस से आने वाले यात्रियों के लिए लागू नहीं
        </p>`;

    const sendEmail = () => {
        const emailParams = (to_email) => {
            return {
                to_email,
                fullName,
                preview_table: previewTable(),
                family_table: familyMembers.length ? tableWrapper(buildRows(familyMembers)): notParticipated
            }
        }

        emailjs.send("service_8m18sys", "template_uh4himl", emailParams(email), "user_sY1m8Ki5Oafoc32NNK9TG");
        // emailjs.send("service_8m18sys", "template_uh4himl", emailParams('hvid1997@gmail.com'), "user_sY1m8Ki5Oafoc32NNK9TG");
    };

    return (
        <div className={classes.rootouter}>
            <svg className={'wavy-divider ' + classes.divider} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 300" preserveAspectRatio="none" width="100%" height="100">
                <path d="M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"></path>
                <path d="M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z"></path>
                <path d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"></path>
            </svg>
          <div className={classes.root}>
                {/* <h6 className="t2" >Registration Form</h6>
                <h2 className="mt-2 t1-sgp" >उत्तरवाहिनी नर्मदा परिक्रमा फॉर्म - 2026</h2> */}
                {/* <h4 className="mt-5" >Registration Closed</h4> */}
                <h4 className='my-4'>
                    <b>Please find the link for Narmada Parikrama registration on the official portal : </b>
                    <a href="https://yatradhamportal.gujarat.gov.in" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold' }}>https://yatradhamportal.gujarat.gov.in</a> 
                </h4>
                {/* <p className='my-4'>
                    <b>Please fill the form carefully.</b> Ensure that all details are correct. Incomplete or incorrect forms may lead to issues.
                    For further details, contact: 9924466383 / अधिक जानकारी हेतु संपर्क करें: 9924466383
                </p> */}

                {/* <Stepper
                    activeStep={activeStep}
                    orientation='vertical'
                    className={`${classes.stepper} ${classes.stepperVertical}`}
                >
                    {steps.map((label, key) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                            <StepContent>
                                <div>{renderStepContent(key)}</div>
                                <div className={classes.actionRow}>
                                    <Button disabled={activeStep === 0} onClick={handleBack}>
                                        Back
                                    </Button>

                                    {activeStep === steps.length - 1 ? (
                                        <Button className={classes.primaryButton} variant="contained" onClick={handleFormSubmit}>
                                            Proceed to Payment
                                        </Button>
                                    ) : (
                                        <Button
                                            className={classes.primaryButton}
                                            variant="contained"
                                            onClick={handleNext}
                                            disabled={(activeStep === 0 && !consentChecked) || (activeStep === 3 && !travelPreference)}
                                        >
                                            Next
                                        </Button>
                                    )}
                                </div>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper> */}
            </div>
            {/* <Snackbar open={message} autoHideDuration={formstatus !== 'success' ? null : 20000} onClose={() => setmessage(false)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <Alert onClose={() => setmessage(false)} severity={formstatus}>
                    {logtext}
                </Alert>
            </Snackbar> */}
        </div>
    );
}

function RulesContent() {
    return (
      <div>
        <h6><b>Terms & Conditions / नियम एवं शर्तें</b></h6>

        {/* <h4>Terms & Conditions / नियम एवं शर्तें</h4> */}

        <ol>
          {/* <li>
            One registration is valid for one person only.<br />
            एक पंजीकरण केवल एक व्यक्ति के लिए मान्य है।
          </li> */}
          <li>
            Registration is mandatory for children above 10 years, elderly who can walk, and all participants coming by personal vehicles.<br />
            10 वर्ष से अधिक आयु के बच्चों, चलने में सक्षम बुजुर्गों तथा निजी वाहन से आने वाले सभी श्रद्धालुओं के लिए पंजीकरण अनिवार्य है।
          </li>
          <li>
            The entire Parikrama will be completed on foot only. All buses and personal vehicles must be parked at the designated parking area near Mani Nageshwar Temple, Tilakwada. After the Parikrama, participants will return to Shri Leela Gaudham from the same parking location.<br />
            पूरी परिक्रमा केवल पैदल ही पूर्ण की जाएगी। बसों और निजी वाहनों को मणि नागेश्वर मंदिर, तिलकवाड़ा के निर्धारित पार्किंग स्थल में पार्क करना होगा। परिक्रमा पूर्ण होने के बाद वहीं से सभी श्रद्धालु अपने वाहनों द्वारा श्री लीला गौधाम लौटेंगे।
          </li>
          <li>
            Travel fee:<br />
            🔅₹250 for participants coming by personal vehicle<br />
            🔅₹600 bus fare from Shri Leela Gaudham to Parikrama site and return to Gaushala<br />
            All participants traveling by personal vehicle or bus must reach the Parikrama site only from Shri Leela Gaudham.<br />
            यात्रा शुल्क:<br />
            🔅निजी वाहन से आने वालों के लिए ₹250<br />
            🔅श्री लीला गौधाम से परिक्रमा स्थल तथा वापस गौशाला तक बस का किराया ₹600<br />
            निजी वाहन या बस से आने वाले सभी श्रद्धालुओं को परिक्रमा स्थल तक केवल श्री लीला गौधाम से ही जाना होगा।
          </li>
          <li>
            Dress Code: Yellow & White<br />
            ड्रेस कोड: पीला और सफेद
          </li>
          <li>
            If you arrive late, you will need to make your own arrangements.<br />
            देर से आने पर अपनी व्यवस्था स्वयं करनी होगी।
          </li>
          <li>
            Last date for registration: 16 March (till 12 midnight). Registration is mandatory.<br />
            पंजीकरण की अंतिम तिथि: 16 मार्च (रात 12 बजे तक)। पंजीकरण अनिवार्य है।
          </li>
          <li>
            For further details, contact: 9924466383<br />
            अधिक जानकारी हेतु संपर्क करें: 9924466383
          </li>
        </ol>
      </div>
    );
}
